import { Reveal, SectionHeading } from "@/components/Reveal";
import { IMAGES } from "@/data/site";

export default function Galleria() {
  return (
    <section id="galleria" className="py-24 md:py-32 lg:py-40 bg-sand/60">
      <div className="max-w-[1400px] mx-auto px-6 md:px-12">
        <SectionHeading
          overline="Galleria"
          title={<>Guarda, scegli <span className="italic text-terracotta">e assapora</span></>}
        />
        <Reveal delay={0.1}>
          <p className="mt-6 max-w-2xl text-charred/70 leading-relaxed">
            Ogni piatto racconta la nostra attenzione per la cucina e per i dettagli. Scopri alcune delle preparazioni realizzate ogni giorno da SAPORÉ.
          </p>
        </Reveal>

        <div className="mt-14 grid grid-cols-2 md:grid-cols-4 auto-rows-[160px] md:auto-rows-[200px] gap-3 md:gap-4">
          {IMAGES.gallery.map((g, i) => (
            <Reveal key={g.src} delay={(i % 4) * 0.06} className={`${g.span} h-full`}>
              <figure className="noise-frame overflow-hidden rounded-[4px] group w-full h-full">
                <img
                  src={g.src}
                  alt={g.alt}
                  loading="lazy"
                  className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
                />
              </figure>
            </Reveal>
          ))}
        </div>

        <Reveal delay={0.1}>
          <p className="mt-6 text-xs text-charred/50">Le immagini sono illustrative: disponibilità e composizione dei piatti possono variare in base alla giornata e alla stagionalità.</p>
        </Reveal>
      </div>
    </section>
  );
}
